/**
 * Created by evgenijsenkevic on 04.09.2024
 */

const SwitchAdminButton = {
    name: "SwitchAdminButton",
    buttonType: "control_button",
    icon: bundles.controlbuttons.frames.switch_icon_png,

    onClicked: function () {
        const scene = cleverapps.Scenes.GetRunningScene();
        const newScene = scene instanceof AdministratorScene ? AdminLocationsScene : AdministratorScene;

        cleverapps.focusManager.display({
            focus: "SwitchAdminButton",
            action: function (f) {
                newScene.open(f);
            }
        });
    },

    isAvailableOnScene: function () {
        const scene = cleverapps.Scenes.GetRunningScene();
        return cleverapps.administrator && cleverapps.administrator.adminLocations
            && cleverapps.oneOf(scene, AdminLocationsScene, AdministratorScene);
    }
};
